import { clsx } from 'clsx'
import type { MouseEventHandler, ReactNode } from 'react'
import { Link, useLocation } from 'react-router'
import { useLanguage } from '#src/hooks/useLanguage.js'
import { languageService } from '#src/languageService.js'

interface NavLinkProps {
  children?: ReactNode
  href: string
  className?: string
  scroll?: boolean
  onClick?: MouseEventHandler<HTMLAnchorElement>
  prefetch?: boolean
}

export function NavLink(props: NavLinkProps): ReactNode {
  const { children, href, scroll = true, className, onClick, prefetch } = props
  const { pathname } = useLocation()
  const lang = useLanguage()

  // Rewrite canonical (English) paths to the active language, e.g. /contact -> /sv/kontakt
  const localizedHref = languageService.localizePath(href, lang)

  return (
    <Link
      to={localizedHref}
      preventScrollReset={!scroll}
      onClick={onClick}
      // Next prefetched all links entering the viewport; hover/focus ("intent")
      // is the saner default, "viewport" for the explicit opt-ins (mobile drawer).
      prefetch={prefetch ? 'viewport' : 'intent'}
      className={clsx(className, {
        active: languageService.normalizePathname(pathname) === localizedHref,
      })}
    >
      {children}
    </Link>
  )
}
